import { QuestionTypeSelect, QuestionSelectOption } from "../../types/gameSession";
import React, { ChangeEvent } from "react";
import { updateOptionAnswer, updateOptionSelected } from "../../app/slices/gameSession";
import { useAppDispatch, useAppSelector } from "../../app/store";

type Props = {
    question: QuestionTypeSelect;
    showPoints: boolean;
};

const QuestionSelect = ({ question, showPoints }: Props) => {
    const { data } = useAppSelector((state) => state.game);
    const pending = useAppSelector((state) => state.gameSession.pending);
    const disabled = pending || !question.can_edit;
    const displayCorrectAnswers = data?.display_correct_answers || false;

    const questionLayout: string = question.layout || "default";

    const renderOptions = question.options.map((option) =>
        option.option_type === "open" ? (
            <QuestionOptionOpen key={option.index} option={option} disabled={disabled} />
        ) : (
            <QuestionOptionBasic
                key={option.index}
                option={option}
                displayCorrectAnswers={displayCorrectAnswers}
                layout={questionLayout}
                disabled={disabled}
            />
        )
    );

    return (
        <>
            {question.image && (
                <div className='question-image-container'>
                    <img
                        src={question.image}
                        alt={question.title}
                        className='question-image'
                    />
                </div>
            )}
            <div className={`select-container ${questionLayout}`}>
                {renderOptions}
            </div>
        </>
    );
};

export default QuestionSelect;

const QuestionOptionBasic = ({
    option,
    displayCorrectAnswers,
    layout,
    disabled
}: {
    option: QuestionSelectOption;
    displayCorrectAnswers: boolean;
    layout: string;
    disabled: boolean;
}) => {
    const dispatch = useAppDispatch();

    const handleSelectOptionClick = (option: QuestionSelectOption) => {
        if (disabled) return;
        dispatch(
            updateOptionSelected({
                optionIndex: option.index,
                selected: !option.selected
            })
        );
    };
    const classNames = `question-option-select ${option.selected ? 'selected' : ''} ${displayCorrectAnswers ? (option.points > 0 ? 'correct' : 'incorrect') : ''
        } ${layout}`.trim();


    return (
        <button type="button" disabled={disabled} key={option.index} className={classNames} onClick={() => handleSelectOptionClick(option)}>
            <div className={`question-option-col`}>
                <div className="question-option-wrapper">
                    <span>{option.option}</span>
                </div>
                {displayCorrectAnswers && (
                    <div className="option-points-sm">
                        <span>
                            {option.points > 0 && '+'}
                            {option.points}
                        </span>
                    </div>
                )}
            </div>
        </button>
    );
};

const QuestionOptionOpen = ({ option, disabled }: { option: QuestionSelectOption; disabled: boolean }) => {
    const dispatch = useAppDispatch();

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (disabled) return;
        dispatch(updateOptionAnswer({optionIndex: option.index, answer: e.target.value, selected: !!e.target.value}));
    };

    return (
        <div key={option.index} className="question-option-select-open ">
            <label className="form-label" htmlFor={`select-open-${option.index}`}>{option.option}</label>
            <input
                id={`select-open-${option.index}`}
                type="text"
                className="form-control"
                value={option.answer || ''}
                disabled={disabled}
                onChange={handleChange}
            />
        </div>
    );
}
